module.exports = __webpack_public_path__ + "static/media/3.98a1a96d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyes/3.png
// module id = 1227
// module chunks = 0